import { useEffect, useState } from 'react';
import css from './Burger.module.scss';
import classNames from 'classnames';

export default function Burger(props) {
    const { onOpen, isClosed = false } = props;
    const [opened, setOpened] = useState(false);

    const handleClick = (e) => {
        setOpened((s) => !s);
        onOpen && onOpen(e);
    };

    useEffect(() => {
        if (isClosed) setOpened(false);
    }, [isClosed]);

    return (
        <div onClick={handleClick} className={classNames(css.burger, { [css.open]: opened })}>
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
}
